module.exports = function() {
  return new Worker(__webpack_public_path__ + "8976a900a24c0488b5c9.worker.js");
};